import React, { useState } from "react";
import Spinner from 'react-bootstrap/Spinner';
import './LandingLayout.css';
import { Row, Col } from 'react-bootstrap';

import Header from "../header/header";
import LeftSidebar from "../sidebar/LeftSidebar";
import RightSidebar from "../sidebar/RightSidebar";
import TourSlide from "../../components/Overlay/TourSlide";
import Loader from "../Loader";


const LandingLayout = (props) => {

    const [showSpinner, setShowSpinner] = useState(props.loading || false);
    const [startTour, setStartTour] = useState(false);
    const [tourItem, setTourItem] = useState("dashboard");

    let hideContent = showSpinner ? " hidden-content" : "";
    // const toggleTour = () => {
    //     // setStartTour(!startTour)
    // }
    return (<>
        <div className="layout-wrapper" >
            <Row className="m-0">
                <Col className="p-0">
                    <Header startTour={setStartTour} tourState={startTour} />
                </Col>
            </Row>
            <Row className="m-0">
                <Col sm className="left-sidebar-wrapper p-0" >
                    <LeftSidebar />
                </Col>

                <Col sm className={`p-0 main-content-wrapper ${props.hideRightPanel ? "hideRightSidebar" : ""}`}>
                    <Row className="page-content-wrapper m-0">

                        <Col className={"p-0 content-wrapper "} >
                            <Loader loading={showSpinner} />
                            <div className={'content-data' + hideContent} >
                                {React.cloneElement(props.children, { isLoading: { showSpinner }, showSpinner: setShowSpinner, setTourItem: setTourItem })}
                            </div>
                        </Col>
                        {!props.hideRightPanel && <Col sm className="right-sidebar-wrapper p-0" >
                            <RightSidebar />
                        </Col>}
                    </Row>
                </Col>

            </Row>
        </div>
        <TourSlide startTour={startTour} stopTour={setStartTour} tourItem={tourItem} />
    </>
    );
};


export default LandingLayout;